import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import file from "../../Assets/LeinaResume.pdf";

const Navbar = ({ currentPage, setCurrentPage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const navbarRef = useRef(null);

    // Check if screen is mobile or tablet
    const isMobileOrTablet = windowWidth <= 1023;
    const isMobile = windowWidth <= 767;

    useEffect(() => {
        // Handle window resize
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            // Close mobile menu when resizing to desktop
            if (window.innerWidth > 1023) {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const handleScroll = (e) => {
            const scrollHeight = e.currentTarget.scrollY;
            
            // Adjust scroll trigger points based on screen size
            const workTriggerPoint = isMobile ? 400 : (isMobileOrTablet ? 480 : 560);
            const contactTriggerPoint = isMobile ? 1800 : (isMobileOrTablet ? 2200 : 2600);
            
            if (scrollHeight > workTriggerPoint && currentPage === "/") {
                setCurrentPage("work");
            } 
            if (scrollHeight < workTriggerPoint && currentPage === "work") {
                setCurrentPage("/");
            }
            if (scrollHeight > contactTriggerPoint && currentPage === "work") {
                setCurrentPage("contact");
            }
            if (scrollHeight < contactTriggerPoint && currentPage === "contact") {
                setCurrentPage("work");
            }
        }

        if (location && location?.pathname && location?.pathname.includes("/project/")) {
            setCurrentPage("work");
        } else {
            if (currentPage === "/" || currentPage === "work" || currentPage === "contact") {
                window.addEventListener('scroll', handleScroll);
            }
        }

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, [currentPage, location, setCurrentPage, isMobileOrTablet, isMobile]);
    
    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target) && isMobileMenuOpen) {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen]);

    const handlePageChange = (page) => {
        // Close mobile menu when navigating
        setIsMobileMenuOpen(false);
        if (page === "work") {
            if (currentPage === "/") {
                window.scrollTo({
                    top: 700,
                    behavior: 'smooth',
                  });
            } else {
                navigate("/");
                setCurrentPage("/");
                setTimeout(() => {
                    window.scrollTo({
                        top: 700,
                        behavior: 'smooth',
                      });
                }, 100)
            }
        } else if (page === "contact") {
            if (currentPage !== "resume") {
                window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: "smooth",
                });
            } else {
                navigate("/");
                setCurrentPage("/");
                setTimeout(() => {
                    window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth',
                      });
                }, 100)
            }
        } else {
            navigate(page);
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
        setCurrentPage(page);
    }

    const downloadResume = () => {
        const link = document.createElement("a");
        link.href = file
        link.download = "Leina_Resume";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

  return (
    <div className='homeV3Navbar_main' ref={navbarRef}>
        {isMobileOrTablet ? (
            <>
                <div className={`homeV3HeaderNav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                    <div className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                        <div className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    
                    <div className={`mobile-menu-items ${isMobileMenuOpen ? 'show' : ''}`}>
                        <div className={`homeV3HeaderNavItem ${currentPage === "/" ? "focused" : ""}`} onClick={() => handlePageChange("/")}>Home</div>
                        <div className={`homeV3HeaderNavItem ${currentPage === "work" ? "focused" : ""}`} onClick={() => handlePageChange("work")}>Work</div>
                        <div className={`homeV3HeaderNavItem ${currentPage === "about" ? "focused" : ""}`} onClick={() => handlePageChange("about")}>About</div>
                        <div className={`homeV3HeaderNavItem ${currentPage === "contact" ? "focused" : ""}`} onClick={() => handlePageChange("contact")}>Contact</div>
                        <div className={`homeV3HeaderNavItem resumeButton ${currentPage === "resume" ? "focused" : ""}`} onClick={() => downloadResume()}></div>
                    </div>
                </div>
            </>
        ) : (
            <div className='homeV3HeaderNav'>
                <div className={`homeV3HeaderNavItem ${currentPage === "/" ? "focused" : ""}`} onClick={() => handlePageChange("/")}>Home</div>
                <div className={`homeV3HeaderNavItem ${currentPage === "work" ? "focused" : ""}`} onClick={() => handlePageChange("work")}>Work</div>
                <div className={`homeV3HeaderNavItem ${currentPage === "about" ? "focused" : ""}`} onClick={() => handlePageChange("about")}>About</div>
                <div className={`homeV3HeaderNavItem ${currentPage === "contact" ? "focused" : ""}`} onClick={() => handlePageChange("contact")}>Contact</div>
                <div className={`homeV3HeaderNavItem resumeButton ${currentPage === "resume" ? "focused" : ""}`} onClick={() => handlePageChange("resume")}></div>
            </div>
        )}
    </div>
  );
};

export default Navbar;
